module.exports = __webpack_public_path__ + "static/media/attack.6c54dda0.png";